import {useHistory} from 'react-router-dom';
import parse from 'html-react-parser';
import classNames from 'classnames';
import {NotificationProps} from '../../../constants/types';
import {getNotificationOptions} from './notificationOptions';

type Props = {
  notification: NotificationProps,
  dismissNotification: () => void,
  handleCloseNotifications: () => void,
  isDismissing: boolean
}

const Notification = ({
  notification, dismissNotification, handleCloseNotifications, isDismissing
}: Props) => {
  const history = useHistory();

  if (!notification) return null;

  const {title, msg, priority} = notification;
  const priorityClass = priority?.toLowerCase();

  return (
    <div
      className={classNames('notification', priorityClass)}
    >
      <p className="title">{title}</p>
      <div className="message">{parse(msg, getNotificationOptions(history, handleCloseNotifications))}</div>
      <button
        onClick={dismissNotification}
        className="dismiss"
        disabled={isDismissing}
      >
        Dismiss
      </button>
    </div>
  );
};

export default Notification;
